import React, { useEffect, useState } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/layout/Layout';
import { initDB } from "react-indexed-db-hook";
import { DBConfig } from './constants/DBConfig';
import { getDataFromLocalStorage, getMachineId, getUserIpAddress, pushUtmSourceInformation, removeDataFromLocalStorage, sendUserDeviceTracking, setDataOnLocalStorage, setDataOnLocalStorageWithExpiry } from './utils/globalUtilities';
import { LocalStorageDataModel } from './constants/local-storage-data-model';
import { getUserInfo } from './services/effects/otherEffects';
import { APIStatus } from './interface/baseInterfaces';
import { Toaster } from 'react-hot-toast';
import "react-toastify/dist/ReactToastify.css";
import { SeoDetails } from './components/seo/seoDetails';
import { ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD } from './features/homepage/constant/endMileAPI.event.list';
initDB(DBConfig);
const App: React.FC = () => {
	const params: any = new URLSearchParams(location.search);
	const { pathname, href } = window.location;
 	const urllocation = useLocation();

	const userIP = getDataFromLocalStorage(LocalStorageDataModel.USER_IP);
	const [machineId, setMachineId] = useState(
		getDataFromLocalStorage(LocalStorageDataModel.MACHINE_ID) ? true : false
	);
	useEffect(() => {
		(async () => {
			await getMachineId().then(() => setMachineId(true));
		})();
		return () => {
			// removeDataFromLocalStorage(LocalStorageDataModel.ENDMILE_USER_DATA);
		};
	}, []);
	useEffect(() => {
		const currentUrl = window.location.href;
		const previousUrl = localStorage.getItem(LocalStorageDataModel.PREVIOUS_URL);
		if (!previousUrl || previousUrl !== currentUrl) {
			localStorage.setItem("PREVIOUS_URL", currentUrl);
		}
	}, [location]);
	useEffect(() => {
		(async () => {
			await getMachineId().then(() => setMachineId(true));
			if (!userIP) {
				await getUserIpAddress().then((data) => {
					storeUtmInfo();
				});
			}
		})();
		// return () => {
		// 	removeDataFromLocalStorage(LocalStorageDataModel.ENDMILE_USER_DATA);
		// };
	}, []);

	useEffect(() => {
		(async () => {
			// initializeGA4EventTrack();
			if (
				getDataFromLocalStorage(LocalStorageDataModel.AUTH_TOKEN)
				// &&
				// !getDataFromLocalStorage(LocalStorageDataModel.EXTRA_NETCORE_PAYLOAD)
			) {
				getUserInfo((response: any) => {
					if (response.ResponseType == APIStatus.SUCCESS) {
						const personalInfo = response.data;

						const {
							firstName,
							lastName,
							designation,
							profession,
							state,
							mobile,
							countrycode,
							company,
							interestId,
							studentInterest,
						} = personalInfo;
						const endMileUserData = [];
						endMileUserData.push({
							fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.FIRST_NAME_LAST_NAME,
							value: firstName + " " + lastName || "",
						});
						endMileUserData.push({
							fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.COUNRTY_CODE,
							value: countrycode,
						});
						endMileUserData.push({
							fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.PHONE_NUMBER,
							value: mobile,
						});
						// endMileUserData.push({
						// 	fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.INSTITUTES,
						// 	value: company || "",
						// });
						endMileUserData.push({
							fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.STATE,
							value: state?.state_name || "",
						});
						endMileUserData.push({
							fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.DESGNATION,
							value: designation?.designationName || "",
						});
			
						if (interestId) {
							const interets = interestId?.map((el: any) => el?.name?.replace(/[^a-z0-9,-.()& ]/gi, ""))?.join("|")
							endMileUserData.push({
								fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.AREA_OF_SPECIALIZATION,
								value: interets,
							});
						} else if (studentInterest) {
							const interets =
								studentInterest?.course?.name?.replace(/[^a-z0-9,-.()& ]/gi, "") +
								"|" +
								studentInterest?.groupLevel?.name?.replace(/[^a-z0-9,-.()& ]/gi, "");
			
							endMileUserData.push({
								fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.AREA_OF_SPECIALIZATION,
								value: interets,
							});
						} else {
							endMileUserData.push({
								fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.AREA_OF_SPECIALIZATION,
								value: "",
							});
						}
			
						endMileUserData.push({
							fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.PROFESSION,
							value: profession?.profession_name || "",
						});
			
						setDataOnLocalStorage(
							LocalStorageDataModel.ENDMILE_USER_DATA,
							JSON.stringify(endMileUserData)
						);

						let netCorePayload: any = {
							name: personalInfo?.lastName
								? personalInfo?.firstName + " " + personalInfo?.lastName
								: personalInfo?.firstName || "",
							designation: personalInfo?.designation?.designationName || "",
							profession:
								personalInfo.profession?.profession_name ||
								personalInfo.professionNameOther ||
								(personalInfo?.studentInterest?.course?.id ? "students" : ""),
							email: personalInfo?.email || "",
							city: personalInfo?.city || "",
							state: personalInfo?.state?.state_name || "",
							phone: personalInfo?.mobile || ""
							// pincode:
						};
						setDataOnLocalStorage(
							LocalStorageDataModel.EXTRA_NETCORE_PAYLOAD,
							JSON.stringify(netCorePayload)
						);
					}
				});
			}
		})();
	}, []);

	useEffect(() => {
		if (userIP) storeUtmInfo();
		(async () => {
			if (
				params.get("utm_medium") &&
				params.get("utm_medium")?.toLowerCase().includes("cid")
			) {
				const utm_medium = params.get('utm_medium')?.toLowerCase();
				const match = utm_medium.match(/cid_?(\d+)/i);
				if (match) {
					const cid = match[1]; 
					setDataOnLocalStorageWithExpiry(LocalStorageDataModel.ENDMILE_EVENTS_CID_NUMBER, cid, 24 * 60 * 60 * 100);
				}
			}
		})();
	}, [params]);
	useEffect(() => {
		const activeCampaign: any = getDataFromLocalStorage(
			LocalStorageDataModel.UTM_CAMPAIGN_NAME
		);
		const utmData: any = getDataFromLocalStorage(activeCampaign);
		if (utmData?.["utm_campaign"] && userIP) {
			pushUtmSourceInformation("Page Viewed " + activeCampaign);
		}
	}, [location, userIP]);

	function storeUtmInfo() {
		if (params.get("utm_campaign")) {
			let utmInfo: any = {};
			params.forEach((value: any, key: any) => {
				if (key.includes("utm_")) {
					utmInfo[key] = value;
				}
			});
			setDataOnLocalStorage(
				params.get("utm_campaign"),
				JSON.stringify(utmInfo)
			);
			setDataOnLocalStorage("activeCampaign", params.get("utm_campaign"));
			setDataOnLocalStorage("activeCampaignUrl", pathname + location.search);
			pushUtmSourceInformation(
				"User Initial visit by " + params.get("utm_campaign")
			);
		}
	}

  useEffect(() => {
    const currentUrl = window.location.href;
    sendUserDeviceTracking(currentUrl);
  }, [urllocation]);
  
      
	return (
		<div>
			{machineId ? <SeoDetails /> : null}
			{machineId ? <Routes>
				<Route path='/*' element={<Layout />} />
			</Routes> : null}
			<div>
				<div>
					<Toaster position="top-center" reverseOrder={false} />
				</div>
			</div>
		</div>
	);
}

export default App;
